import { useLocation, useNavigate, useParams  } from 'react-router-dom';
import { useRefresh } from '../Registration/RegCommon/RefresContext';

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const refresh = useRefresh()

    return (
      <Component
        navigate={navigate}
        params={params}
        location={location}
        refresh = {refresh}
        {...props}
        />
    );
  };
  
  return Wrapper;
};